<template>
    <div class="outer">
        <div class="scope-item" :class="{selected}" @click="clicked">
            <flex-row gap vcenter>
                <flex-cell class="select-mark" shrink>
                    <ux-icon :icon="selected ? 'fa-check' : 'fa-regular fa-circle'" />
                </flex-cell>
                <flex-cell shrink>
                    <ux-circle :value="item" />
                </flex-cell>
                <flex-cell class="scope-title">
                    {{item.title}}
                </flex-cell>
                <flex-cell class="definition-title" v-if="definition" shrink>
                    {{definition.title}}
                </flex-cell>
                <flex-cell shrink v-if="hasChildren">
                    <!-- <div :class="{hide:!hasChildren}"> -->
                        <ux-button @click.stop.prevent="toggleCollapse()" size="xs" icon>
                            <ux-icon :icon="expanded ? 'fa-angle-up' : 'fa-angle-down'" />
                        </ux-button>
                    <!-- </div> -->
                </flex-cell>
            </flex-row>
        </div>
        <div class="children" v-if="expanded">
            <scope-item :click="click" :item="child" v-for="child in item.children" />
        </div>
    </div>
</template>
<script>

import UxCircle from '../ui/circle.vue';

export default {
    components:{
        UxCircle,
    },
    props: {
        item: {
            type: Object,
        },
        click: {
            type: Function,
        },
    },
    data() {
        return {
            glossary:{},
        }
    },
    methods: {
        clicked() {
            this.click(this.item);
        },
        toggleCollapse() {
            return this.item.collapsed = !this.collapsed;
        }
    },
    async created() {
        this.glossary = await this.$sdk.content.glossary({ hash: true });
    },
    inject: {
        isSelected:{
        default() {
            return;
        }
        }
    },
    computed: {
        definition() {
            const self = this;
            const definitionKey = this.item?.meta?.definition;

            if(!definitionKey) {
                return;
            }


            return this.glossary[definitionKey]

        },
    	selected() {
    		return this.isSelected(this.item);
    	},
        hasChildren() {
            return this.item.children?.length;
        },
        expanded() {
            return !this.collapsed;
        },
        collapsed() {
            return !this.hasChildren || this.item.collapsed;
        },
    },
}
</script>
<style lang="scss" scoped>
.outer {}

.scope-item {
    padding: 0.6em 1em;
    background: var(--bg1, #fff);
    border: 1px solid color-mix(in lab, currentColor 20%, transparent);
    display: block;
    margin-bottom: 0.1em;
    border-radius: 0.3em;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
        color: color-mix(in lab, currentColor 80%, transparent);
    }

    .select-mark {
    	transition:all 0.2s;
    	transform:scale(0.5);
    	opacity: 0.3;
    }

    &.selected {
        opacity: 1;
    	.select-mark {
    		transform:scale(1);
    		opacity: 0.8;
    	}
    }
}

.hide {
    visibility: hidden;
}

.children {
    position: relative;
    padding-left: 1em;
    margin-left: 1em;
    padding-right: 0.3em;

    .scope-item {
        position: relative;

        &:after {
            content: '';
            display: block;
            width: 1em;
            left: -1em;
            top: 1.6em;
            position: absolute;
            border-top: 1px dotted color-mix(in lab, currentColor 20%, transparent);
        }
    }




    &:after {
        content: '';
        display: block;
        width: 1px;
        height: calc(100% - 0.9em);
        top: 0;
        left: 0;
        position: absolute;
        border-left: 1px dotted color-mix(in lab, currentColor 20%, transparent);
    }
}



.definition-title {
    opacity: 0.5;
    font-size: 0.8em;
}
</style>